export default __webpack_public_path__ + "static/media/bg_search_page.c449b03f.gif";